<template>
  <form @submit.prevent="filterPosTransactions()">
    <div class="row">
      <div class="col-lg-2 col-md-4">
        <base-input
          type="text"
          :label="$t('cardsPage.filterForm.publicIdLbl')"
          placeholder=""
          v-model="publicId"
        >
        </base-input>
      </div>
      <div class="col-lg-4 col-md-6 pl-0 align-self-end">
        <div class="form-group">
          <base-button
            :loading="loading"
            native-type="submit"
            type="default"
            class="btn-fill mb-0"
          ><i class="tim-icons icon-light-3  pr-2"/> {{ $t('cardsPage.filterForm.actionBtn') }}
          </base-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import {mapActions, mapState} from "vuex";

  export default {
    name: 'cardsFilterForm',
    components: {
    },
    props: {
      filterDetails: {
        type: Object,
        required: false,
      },
    },
    methods: {
      ...mapActions(['LoadCards']),
      filterPosTransactions() {
        let apiQuery = {
          publicId: this.publicId
        }
        this.LoadCards(apiQuery)
      }
    },
    computed: {
      ...mapState({
        loading: state => state.cards.loading,
      }),
    },
    data() {
      return {
        publicId: ""
      };
    },
    mounted() {
      if (this.filterDetails) {
        this.publicId = this.filterDetails.publicId
      }
    }
  };
</script>
<style>
</style>
